/**
 * @file duration.ts
 * @brief "15m", "1h 05m", "45s": a session's or meeting's length on a card,
 *        the phone's `formatSessionDuration` (FRONTEND SessionCard.tsx).
 *
 * @details
 * Every web card's time reads the same (Home rails, Boardroom library; DES
 * 04-10-2026). Here rather than in a component file so those keep their
 * Fast Refresh.
 *
 * @author DES
 * @date 04-10-2026
 */

export function formatSessionDuration(secs?: number | null): string {
  const s = Math.max(0, Math.round(Number(secs) || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
}
